<template lang="pug">
  SspLayout(area="core")
    .row.create-code-config
      .col-md-12
        SspSaveForm(@onSubmit="save" :saveDisabled="!isValid" :saving="saving")
          .form-horizontal
            .form-group
              label.col-sm-3.control-label Type
              button.btn.btn-default.ml15(v-for="(tp, index) in typeButtons" :class=" { active: activeTypeIndex === index } " @click="selectType(tp.value, index)" type="button") {{tp.text}}
            span(v-if="codeConfig.type === 'KZ'")
              .form-group
                label.col-sm-3.control-label Description
                .col-sm-7
                  input.form-control(v-model="codeConfig.description")
              .form-group
                label.col-sm-3.control-label Alias
                .col-sm-7
                  input.form-control(v-model="codeConfig.alias")
              .form-group
                label.col-sm-3.control-label Alphabet
                .col-sm-7
                  input.form-control(v-model="codeConfig.alphabet")
                  span.red(v-if="alphabetDuplicate") {{duplicateMsg}}
              .form-group
                label.col-sm-3.control-label Reference Length
                .col-sm-7
                  input.form-control(v-model.number="codeConfig.referenceLength" type="number")
              .form-group
                label.col-sm-3.control-label Counter Length
                .col-sm-7
                  input.form-control(v-model.number="codeConfig.counterLength" type="number")
              .form-group
                label.col-sm-3.control-label Security Length
                .col-sm-7
                  input.form-control(v-model.number="codeConfig.securityLength" type="number")
              .form-group
                label.col-sm-3.control-label Min Length
                .col-sm-7
                  input.form-control(:value="minLength" type="number" :disabled="true")
              .form-group
                label.col-sm-3.control-label Default Length
                .col-sm-7
                  input.form-control(v-model.number="codeConfig.defaultCodeLength" type="number")
                  .red(v-if="!isValid") Default length must be between min and max length
              .form-group
                label.col-sm-3.control-label Max Length
                .col-sm-7
                  input.form-control(v-model="codeConfig.maxCodeLength" type="number")
              .form-group
                label.col-sm-3.control-label Max Number of Orders
                .col-sm-7
                  input.form-control(:value="maxOrders | number" :disabled="true")
              .form-group
                label.col-sm-3.control-label Max Number of Codes
                .col-sm-7
                  input.form-control(:value.number="maxCodes | number" :disabled="true")
              .form-group
                label.col-sm-3.control-label Max Number of Codes per Order
                .col-sm-7
                  input.form-control(:value="codesPerOrder | number" :disabled="true")
            span(v-if="codeConfig.type === 'EXT'")
              .form-group
                label.col-sm-3.control-label Description
                .col-sm-7
                    input.form-control(v-model="codeConfig.description")
              .form-group
                label.col-sm-3.control-label Alias
                .col-sm-7
                  input.form-control(v-model="codeConfig.alias")
              .form-group
                label.col-sm-3.control-label Min Length
                .col-sm-7
                  input.form-control(v-model="extMinlength" type="number")
</template>

<script>
import miniToastr from 'mini-toastr'
import Core from '@/service/apis/Core'
import { numberFilter } from '@/filters/filters'

export default {
  data: () => ({
    saving: false,
    activeTypeIndex: 0,
    extMinlength: null,
    typeButtons: [
      { text: 'Kezzler Config', value: 'KZ' },
      { text: 'External Config', value: 'EXT' }
    ],
    mo: 0,
    cpo: 0,
    duplicateMsg: 'Duplicate characters in alphabet input',
    errorMsg: null,
    codeConfig: {
      alias: null,
      maxCodeLength: null,
      description: null,
      defaultCodeLength: null,
      type: 'KZ',
      alphabet: null,
      counterLength: 0,
      securityLength: 0,
      referenceLength: 0
    }
  }),
  methods: {
    selectType(value, index) {
      this.activeTypeIndex = index
      this.codeConfig.type = value
    },
    save() {
      this.saving = true
      const req = {
        type: this.codeConfig.type,
        description: this.codeConfig.description,
        alias: this.codeConfig.alias
      }

      if (this.codeConfig.type === 'EXT') {
        req.minLength = this.extMinlength
      } else {
        req.minCodeLength = this.minLength
        req.maxCodeLength = this.codeConfig.maxCodeLength
        req.defaultCodeLength = this.codeConfig.defaultCodeLength
        req.alphabet = this.codeConfig.alphabet
        req.counterLength = this.codeConfig.counterLength
        req.securityLength = this.codeConfig.securityLength
        req.referenceLength = this.codeConfig.referenceLength
      }
      Core.createCodeConfig(req)
        .then(() => {
          this.$router.push({ name: 'codeConfigurations' })
          miniToastr.success('Code configuration successfully saved')
        })
        .catch((e) => {
          this.$emit('error', e)
        })
        .then(() => {
          this.saving = false
        })
    }
  },
  computed: {
    minLength() {
      return parseInt(this.codeConfig.counterLength + this.codeConfig.securityLength + this.codeConfig.referenceLength, 10)
    },
    maxOrders() {
      return this.codeConfig.alphabet ? parseInt(this.codeConfig.alphabet.length ** this.codeConfig.referenceLength, 10) : 0
    },
    maxCodes() {
      return this.codesPerOrder && this.maxOrders ? parseInt(this.codesPerOrder * this.maxOrders, 10) : 0
    },
    codesPerOrder() {
      return this.codeConfig.alphabet ? parseInt(this.codeConfig.alphabet.length ** this.codeConfig.counterLength, 10) : 0
    },
    alphabetDuplicate() {
      if (this.codeConfig.alphabet) {
        const str = this.codeConfig.alphabet
        const arrLength = str.length
        for (let i = 0; i < arrLength; i += 1) {
          const temp = str[i]
          for (let x = i + 1; x <= arrLength - 1; x += 1) {
            if (temp === str[x]) {
              return true
            }
          }
        }
      }
      return false
    },
    isValid() {
      if (this.codeConfig.defaultCodeLength) {
        return this.codeConfig.defaultCodeLength && (this.codeConfig.defaultCodeLength >= this.minLength && this.codeConfig.defaultCodeLength <= this.codeConfig.maxCodeLength)
      }
      return true
    }
  },
  filters: {
    number: numberFilter
  }
}
</script>

<style lang="scss">
.create-code-config {
  .active {
    color: white !important;
    border-color: #004FE1 !important;
    background-color: #004FE1 !important;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/pages/core/configuration/codeconfiguration/CreateCodeConfiguration.vue